const { default: axios } = require("axios");

const FormAjax = function () {

    const formAjax = function (e) {
        const form = $(this);
        const values = form.serialize();
        const button = form.find('button');

        button.attr('disabled', 'disabled');
        button.text('Enviando');

        axios.post(form.attr('action'), values)
            .then(function (response) {
                const data = response.data;

                if (data.error == false) {
                    form.prepend('<div class="alert alert-success w-100" role="alert">' + data.message + '</div>');
                }else{
                    form.prepend('<div class="alert alert-danger w-100" role="alert">' + data.message + '</div>');
                }

                setTimeout(() => {
                    form.find('.alert').slideToggle('slow', function(){
                        $(this).remove();
                    });
                }, 5000);

                button.removeAttr('disabled');
                button.text('Enviar');                
            });

        e.preventDefault();
    }

    return {
        init: function () {
            $(document).on('submit', '.form-ajax', formAjax);
        }
    }
}();

module.exports = FormAjax;